import React, { useState } from 'react';

import { Badge, Input } from 'antd';

import styled from 'styled-components';

import ContactsFiltersActiveSummary from '@components/ContactsSelector/Common/ContactsFiltersActiveSummary';
import ContactsFiltersSidebar from '@components/ContactsSelector/Common/ContactsFiltersSidebar';
import {
    useContactsSelector,
    useContactsSelectorDispatch,
} from '@components/ContactsSelector/Common/ContactsSelectorContext';
import useContactsFiltersSummary from '@components/ContactsSelector/Common/UseContactsFiltersSummary';
import { MOBILE_FILTERS_ZINDEX } from '@components/Filters/FilterForm/FilterFormUI';
import { NwButton } from '@components/Gui/NwButton';
import NwDrawer from '@components/Gui/NwDrawer';
import NwIcon from '@components/Gui/NwIcon';

import { byPrefixAndName } from '@awesome.me/kit-d6dae216cd/icons';

const Wrapper = styled.div`
    padding: 0.5rem 1rem 0.75rem 1rem;

    .filters-bar-actions {
        display: flex;
        align-items: flex-start;
        justify-content: space-between;
        gap: 1rem;
        padding-top: 0.5rem;
    }
`;

const DrawerContent = styled.div`
    /* lascia spazio al footer sticky */
    padding-bottom: 5rem;
`;

const DrawerFooter = styled.div`
    position: fixed;
    bottom: 0;
    left: 0;
    width: 100%;
    padding: 0.75rem 1rem;
    background: #fff;
    border-top: 1px solid ${(props) => props.theme.LighterBorderColor};
    z-index: 1;
`;

// I quick filters non hanno un contatore proprio: si confrontano con i default della wall.
/**
 * Barra compatta mostrata al posto della sidebar dei filtri sotto i 1024px:
 * ricerca per nome sempre visibile, il resto della sidebar in un drawer a tutta pagina.
 */
const ContactsFiltersMobileBar = ({ nItems, ...filtersProps }) => {
    const [isPanelOpen, setIsPanelOpen] = useState(false);

    const { selection } = useContactsSelector();
    const cs_dispatch = useContactsSelectorDispatch();
    const { quickFilters } = selection;

    // Il badge conta esattamente le chip del riepilogo, così i due non possono divergere
    const { chips } = useContactsFiltersSummary();

    const handleChangeNameFilter = (value) => {
        cs_dispatch({
            type: 'ChangeQuickFilters',
            quickFilters: { ...quickFilters, globalNameFilter: value },
        });
    };

    return (
        <Wrapper>
            <Input
                size="large"
                allowClear
                autoComplete="off"
                placeholder="Filter by name"
                prefix={<NwIcon icon={byPrefixAndName.fasl['search']} />}
                onChange={(e) => handleChangeNameFilter(e.target.value)}
                value={quickFilters.globalNameFilter}
            />
            <div className="filters-bar-actions">
                <ContactsFiltersActiveSummary onClick={() => setIsPanelOpen(true)} />
                <Badge count={chips.length} size="small" offset={[-4, 4]}>
                    <NwButton
                        ghost
                        size="small"
                        icon={byPrefixAndName.fasl['filters']}
                        label="filters"
                        onClick={() => setIsPanelOpen(true)}
                    />
                </Badge>
            </div>
            {isPanelOpen && (
                <NwDrawer
                    title="Filters"
                    padding="1rem"
                    width="100vw"
                    zIndex={MOBILE_FILTERS_ZINDEX}
                    onClose={() => setIsPanelOpen(false)}
                >
                    <DrawerContent>
                        <ContactsFiltersSidebar {...filtersProps} isMobileDrawer />
                    </DrawerContent>
                    <DrawerFooter>
                        <NwButton
                            primary
                            block
                            label={`show ${nItems} ${filtersProps.itemType}s`}
                            onClick={() => setIsPanelOpen(false)}
                        />
                    </DrawerFooter>
                </NwDrawer>
            )}
        </Wrapper>
    );
};

export default ContactsFiltersMobileBar;
